<template>
  <div class="header header-bg">
    <div class="nav-container">
      <div class="title">
        <h1>{{ warehouseMessage }}</h1>
        <span class="vl"></span>
        <h2>{{ teamMessage }}</h2>
      </div>
      <DropDownList :style="{ width: '230px', height: '30px' }" class="localeDropDownList" :value="currentLocale"
        :text-field="'language'" @change="localeChange" :data-items="locales">
      </DropDownList>
      <DropDownList :style="{ width: '60px', height: '30px', marginLeft: '8px' }" :data-items="themes" :text-field="'text'" :popup-settings="themesPopupSettings"
        :value-render="myDropDownValueTemplate" class="ddl-theme" @change="onThemeChange">
        <template v-slot:myDropDownValueTemplate="{}">
          <div style="margin: auto 8px auto 10px;">
            <span class="k-icon k-i-palette"> </span>
          </div>
        </template>
      </DropDownList>
      <router-link :to="profileLink" class="header__profile-avatar">
        {{ profile?.name || '' }}
      </router-link>
    </div>
  </div>
</template>
<script>
import {DropDownList} from "@progress/kendo-vue-dropdowns";
import {provideLocalizationService} from "@progress/kendo-vue-intl";
import {useAppStore} from "@/stores/app";
import {getRole} from '@/utils/router.js'
import api from '@/api'

export default {
  components: {
    DropDownList,
  },
  emits: {
    localeChange: null,
    themeChange: null,
  },
  inject: {
    kendoLocalizationService: { default: null },
  },

  computed: {
    warehouseMessage() {
      return provideLocalizationService(this).toLanguageString(
        "warehouse",
        "The Dome"
      );
    },
    teamMessage() {
      return provideLocalizationService(this).toLanguageString("team", "Team");
    },

    profileLink() {
      const role = getRole();

      switch (role) {
        case "supplier/":
          return '/supplier/profile';

        case "client/":
          return '/client/profile';

        default:
          return '/admin/profile';
      }
    }
  },

  methods: {
    onThemeChange(e) {
      this.theme = e.value.href;
      const linkTag = document.getElementById("theme-link");
      linkTag.setAttribute(
        "href",
        `${process.env.BASE_URL}/static/themes/kendo-theme-${this.theme}/all.css`
      );
      this.$emit("themeChange", e.value.text);
    },
    localeChange(e) {
      this.currentLocale = e.target.value;
      const appStore = useAppStore();
      appStore.setLang(e.value.locale);
      this.$emit("localeChange", this.currentLocale);
    },

    async getProfile() {
      try {
        const { data } = await api.profile.get();
        this.profile = data.data;

      } catch(err) {
        console.error(err);
      }
    }
  },
  created() {
    this.currentLocale = this.locales[0];
    this.getProfile();
  },
  data() {
    return {
      theme: "default",
      themes: [
        {
          href: "default",
          text: "Default",
        },
        {
          href: "bootstrap",
          text: "Bootstrap",
        },
        {
          href: "material",
          text: "Material",
        },
      ],
      myDropDownValueTemplate: "myDropDownValueTemplate",
      themesPopupSettings: {
        width: "150px",
      },
      currentLocale: null,
      locales: [
        {
          language: "Русский",
          locale: "ru",
        },
        {
          language: "English",
          locale: "en",
        }
      ],
      profile: {}
    };
  },
};
</script>

<style scoped>
.ddl-theme {
  width: 60px;
  min-width: 60px;
}

.localeDropDownList {
  min-width: 100px;
  margin: 10px;
}

.k-dropdownlist {
  min-height: 30px;
}

.header {
  padding: 0 25px 0 0;
}

.header__profile-avatar {
  color: #ffff;
  padding-left: 1rem;
  font-size: 18px;
}
</style>